import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  showMessage,
  openLoaderWithMessage,
  closeLoaderWithMessage,
} from "../redux/messages/messagesActions";
import { downLoadFile } from "../components/FileUpload/utils";
import { config } from "../config";

export const useFileDownloader = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const downloadFile = async (fileUrl: string | undefined) => {
    if (!fileUrl) {
      dispatch(
        showMessage({
          type: "error",
          message: "No file URL available for download",
          displayAs: "snackbar",
        })
      );
      return;
    }

    // Remove S3 prefix if needed
    const s3Prefix = `${config.assets.s3BaseUrl}/`;
    if (fileUrl.startsWith(s3Prefix)) {
      fileUrl = fileUrl.replace(s3Prefix, "");
    }

    try {
      setLoading(true);
      dispatch(openLoaderWithMessage("Downloading file..."));

      await downLoadFile(fileUrl);

      dispatch(
        showMessage({
          type: "success",
          message: "File downloaded successfully",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err?.message || "Download failed",
          displayAs: "snackbar",
        })
      );
    } finally {
      setLoading(false);
      dispatch(closeLoaderWithMessage());
    }
  };

  return {
    downloadFile,
    loading,
  };
};
